/**
 * Safe-area handshake with Hami (same idea as Telegram Mini Apps' contentSafeAreaInset).
 *
 * In the new app the floating bottom nav overlays the page. The chats page tells the Hami iframe
 * how many px at the bottom it covers; Hami pads its scrollable content by that much (content
 * still scrolls under the nav). Hami answers SUPPORTED once, and only then does the chats page
 * run the iframe full height under the nav — until then it stays above the nav, so nothing hides.
 *
 * parent → Hami: { type: 'P24_SAFE_AREA_INSETS', bottom: number }   (on load and on every change)
 * Hami → parent: { type: 'P24_SAFE_AREA_INSETS_SUPPORTED' }         (once, after the first one)
 */
export const SAFE_AREA_INSETS_MESSAGE = 'P24_SAFE_AREA_INSETS';
export const SAFE_AREA_INSETS_SUPPORTED_MESSAGE = 'P24_SAFE_AREA_INSETS_SUPPORTED';
